const lightbox = GLightbox({
    touchNavigation: true,
    loop: true
});
